"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFormatRounding = exports.NumberFormat = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _decimal = _interopRequireDefault(require("decimal.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NumberFormatRounding = {
  DOWN: _decimal.default.ROUND_DOWN,
  UP: _decimal.default.ROUND_UP
};
exports.NumberFormatRounding = NumberFormatRounding;
var NumberFormat = function NumberFormat(_ref) {
  var value = _ref.value,
    Component = _ref.component,
    decimals = _ref.decimals,
    _ref$rounding = _ref.rounding,
    rounding = _ref$rounding === void 0 ? NumberFormatRounding.DOWN : _ref$rounding,
    trimZeros = _ref.trimZeros;
  var formatted = value;
  if (decimals && value) {
    var dValue = new _decimal.default(value);
    formatted = dValue.toFixed(decimals, rounding);
    // trim zeros
    var dp = new _decimal.default(formatted).dp();
    if (trimZeros) decimals = dp || 0;
  }
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    value: formatted,
    thousandSeparator: " ",
    decimalSeparator: ".",
    isNumericString: true,
    decimalScale: decimals,
    renderText: function renderText(formattedValue) {
      if (Component) return /*#__PURE__*/_react.default.createElement(Component, {
        value: {
          raw: value,
          formatted: formattedValue
        }
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formattedValue);
    },
    displayType: "text"
  });
};
exports.NumberFormat = NumberFormat;